<forge-list-item (click)="fireOnClick()" ng-aria-disable (keyup)="navItemKeyup($event)" class="setup-item"
  [ngClass]="selectedClass" (contextmenu)="contextMenu($event)" [dense]="compactMode" role="" [selected]="selected">
  <button type="button" [disabled]="disabled">
    <div class="forge-menu-expansion--child" fxLayout="row" fxLayoutAlign="space-between center">
      <truncate-text [mainText]="name"></truncate-text>
      @if (hasError) {
        <forge-icon name="error_outline" class="error-red">error_outline</forge-icon>
      }
    </div>
  </button>
</forge-list-item>
